// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1AFXz","inner":"Footer_inner__2lRqE","nextIcon":"Footer_nextIcon__1YRja","innerLeft":"Footer_innerLeft__3f5tx"};